import { AccountType, ActionType, Slug } from "../constants";

const getItem = (key) => {
  const item = localStorage.getItem(key);
  return item === "null" ? null : item;
};

export const getUser = () => {
  const contactInfo = getItem("contactInfo");
  const contactType = getItem("contactType");
  const loginToken = getItem("loginToken");
  const firstName = getItem("firstName");
  const lastName = getItem("lastName");
  const accountType = getItem("accountType");
  return {
    contactInfo,
    contactType,
    loginToken,
    firstName,
    lastName,
    accountType,
  };
};

export const getToken = () => {
  return getItem("loginToken");
};

export const setUserSession = ({
  contactInfo,
  contactType,
  loginToken,
  firstName,
  lastName,
  accountType,
}) => {
  localStorage.setItem("contactInfo", contactInfo);
  localStorage.setItem("contactType", contactType);
  localStorage.setItem("loginToken", loginToken);
  localStorage.setItem("firstName", firstName);
  localStorage.setItem("lastName", lastName);
  localStorage.setItem("accountType", accountType);
};

export const resetUserSession = () => {
  localStorage.removeItem("contactInfo");
  localStorage.removeItem("contactType");
  localStorage.removeItem("loginToken");
  localStorage.removeItem("firstName");
  localStorage.removeItem("lastName");
  localStorage.removeItem("accountType");
};

export const logout = (navigate, dispatch) => {
  const isGig = getUser().accountType === AccountType.gig;
  resetUserSession();
  dispatch({ type: ActionType.logout });
  navigate(isGig ? Slug.surveyGigInitial : Slug.surveyInitial);
};
